import { ShieldAlert, LogOut, Phone } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/authContext';
import { toast } from 'react-toastify';
import SummaryApi from '../common'; // We need this for logout

const SuspendPage = () => {
    // 1. Get user from context
    const { user } = useAuth(); 
    const navigate = useNavigate();

    // 2. Add the loading guard for refresh
    if (!user) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                Loading...
            </div>
        );
    }

    // 3. Create the logout handler (copied from your other component)
    const handleLogout = async () => {
        try {
          const res = await fetch(SummaryApi.logout.url, {
            method: SummaryApi.logout.method,
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
          });
          if (res.ok) {
            localStorage.removeItem("authToken");
            toast.success("Logout successful");
            navigate("/login");
          } else toast.error("Logout failed");
        } catch (err) {
          toast.error("Network error");
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
            <div className="w-full max-w-lg p-8 sm:p-12 text-center bg-white rounded-lg shadow-xl">
                
                <ShieldAlert className="w-16 h-16 mx-auto text-red-500" strokeWidth={1.5} />
                
                <h1 className="mt-4 text-3xl font-bold text-gray-800">
                    Your Account is Suspended
                </h1>
                
                <p className="mt-4 text-lg text-gray-600">
                    {/* 4. This is now safe because of the loading guard */}
                    Hi {user.name}, your access to the dashboard and all features is restricted.
                </p>
                
                {/* --- Actions --- */}
                <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
                    <button
                        // 5. Point to the new handler
                        onClick={handleLogout}
                        className="flex items-center justify-center w-full px-6 py-3 text-base font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md shadow-sm hover:bg-gray-200"
                    >
                        <LogOut className="w-5 h-5 mr-2" aria-hidden="true" strokeWidth={2} />
                        Logout
                    </button>
                </div>

                {/* --- Contact Info Text --- */}
                <div className="mt-8 pt-6 border-t border-gray-200">
                    <div className="text-sm text-gray-600 flex flex-col items-center gap-1">
                        
                        {/* Changed this div to explicitly use flex and items-center */}
                        <div className="flex items-center justify-center gap-2"> 
                            <Phone className="w-4 h-4 text-gray-500" />
                            <span>Your account is suspended. Please contact the admin.</span>
                        </div>

                        {/* This stays the same */}
                        <span>Call +91 9309140606</span>
                        
                    </div>
                </div>

            </div>
        </div>
        // 6. All Modals and Renewal Forms are removed.
    );
}

export default SuspendPage;